import React, { useState } from "react";
import { motion } from "framer-motion";
import fondo6 from "../../assets/images/fondo6.jpg";
import Swal from "sweetalert2";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "../../assets/styles/Asesoria.css";

function FormularioInscripcion() {
  const { userData } = useAuth();
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    PrimerNombre: "",
    SegundoNombre: "",
    ApellidoPaterno: "",
    ApellidoMaterno: "",
    Celular: "",
    Correo: "",
    IdEspe: "",
    Carrera: "",
    NivelSemestre: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validaciones personalizadas
    const {
      PrimerNombre,
      ApellidoPaterno,
      ApellidoMaterno,
      Celular,
      Correo,
      IdEspe,
      Carrera,
      NivelSemestre
    } = formData;

    // Validar campos obligatorios
    if (
      !PrimerNombre ||
      !ApellidoPaterno ||
      !ApellidoMaterno ||
      !Celular ||
      !Correo ||
      !IdEspe ||
      !Carrera ||
      !NivelSemestre
    ) {
      Swal.fire("Campos obligatorios", "Por favor, completa todos los campos requeridos.", "warning");
      return;
    }

    // Validar celular (10 dígitos numéricos)
    if (!/^\d{10}$/.test(Celular)) {
      Swal.fire("Celular inválido", "El número de celular debe tener 10 dígitos numéricos.", "error");
      return;
    }

    // Validar correo
    const correoRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!correoRegex.test(Correo)) {
      Swal.fire("Correo inválido", "Por favor, ingresa un correo electrónico válido.", "error");
      return;
    }

    // Validar ID ESPE (mínimo 6 caracteres, ajustable)
    if (IdEspe.length < 9) {
      Swal.fire("ID ESPE inválido", "El ID ESPE debe tener al menos 9 caracteres.", "error");
      return;
    }

    // Mostrar loading
    Swal.fire({
      title: "Enviando inscripción...",
      text: "Por favor espera.",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    // Envío
    try {
      const res = await fetch(`${API}/api/inscripciones/crear`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!res.ok) throw new Error("Error al registrar inscripción");

      Swal.close();
      Swal.fire("✅ Registrado", "Inscripción enviada con éxito", "success");

      // Reset
      setFormData({
        PrimerNombre: "",
        SegundoNombre: "",
        ApellidoPaterno: "",
        ApellidoMaterno: "",
        Celular: "",
        Correo: "",
        IdEspe: "",
        Carrera: "",
        NivelSemestre: ""
      });
    } catch (error) {
      Swal.close();
      Swal.fire("❌ Error", error.message, "error");
    }
  };


  return (
    <main
      className="py-4 px-6 flex items-center justify-center"
      style={{
        backgroundImage: `url(${fondo6})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="bg-white bg-opacity-95 shadow-2xl rounded-3xl p-10 space-y-8 max-w-5xl">
          <h2 className="text-4xl font-extrabold text-center text-green-900 mb-4">
            ¡Forma parte del cambio en la ESPE!
          </h2>
          <p className="text-center text-gray-700 text-lg">
            Si eres estudiante de la <strong>Universidad de las Fuerzas Armadas ESPE</strong>, esta es tu oportunidad para sumarte a nuestro proyecto universitario.
            Queremos trabajar contigo, construir juntos y hacer una diferencia. 🙌
          </p>
          <p className="text-center text-gray-600 mb-4">
            Llena el formulario a continuación y nos pondremos en contacto contigo. ¡Tu participación es muy valiosa!
          </p>

          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                ["PrimerNombre", "Primer Nombre"],
                ["SegundoNombre", "Segundo Nombre"],
                ["ApellidoPaterno", "Apellido Paterno"],
                ["ApellidoMaterno", "Apellido Materno"],
                ["Celular", "Celular"],
                ["Correo", "Correo Electrónico"],
                ["IdEspe", "ID ESPE"],
              ].map(([name, label]) => (
                <div key={name}>
                  <label className="block font-semibold text-gray-700 mb-1">
                    {label}
                  </label>
                  <input
                    name={name}
                    type="text"
                    value={formData[name]}
                    onChange={handleChange}
                    required
                    className="w-full p-3 border rounded-xl"
                  />
                </div>
              ))}

              {/* Select para Carrera */}
              <div>
                <label className="block font-semibold text-gray-700 mb-1">
                  Carrera
                </label>
                <select
                  name="Carrera"
                  value={formData.Carrera}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border rounded-xl"
                >
                  <option value="">-- Selecciona tu carrera --</option>
                  <option value="TICS y SOFTWARE">TICS y SOFTWARE</option>
                  <option value="Contabilidad y Auditoria">CONTABILIDAD Y AUDITORIA</option>
                  <option value="Economia en Linea">ECONOMÍA EN LÍNEA</option>
                  <option value="Administracion de empresas">ADMINISTRACIÓN DE EMPRESAS</option>
                </select>
              </div>

              {/* Select para NivelSemestre */}
              <div>
                <label className="block font-semibold text-gray-700 mb-1">
                  Nivel / Semestre
                </label>
                <select
                  name="NivelSemestre"
                  value={formData.NivelSemestre}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border rounded-xl"
                >
                  <option value="">-- Selecciona el semestre --</option>
                  <option value="Primer Semestre">PRIMER SEMESTRE</option>
                  <option value="Segundo Semestre">SEGUNDO SEMESTRE</option>
                  <option value="Tercer Semestre">TERCER SEMESTRE</option>
                  <option value="Cuarto Semestre">CUARTO SEMESTRE</option>
                  <option value="Quinto Semestre">QUINTO SEMESTRE</option>
                  <option value="Sexto Semestre">SEXTO SEMESTRE</option>
                  <option value="Séptimo Semestre">SÉPTIMO SEMESTRE</option>
                  <option value="Octavo Semestre">OCTAVO SEMESTRE</option>
                </select>
              </div>
            </div>

            <div className="text-center mt-4">
              <button
                type="submit"
                className="bg-green-700 text-white px-6 py-3 rounded-xl hover:bg-green-800"
              >
                Enviar inscripción
              </button>
            </div>
          </form>
        </div>
      </motion.div>
    </main>
  );
}

export default FormularioInscripcion;